/** Pure time-slot helpers shared across booking sub-components. */

export const timeToHour = (timeString) => {
  if (!timeString) return null;
  const [time, period] = timeString.split(' ');
  const [hour] = time.split(':');
  let hourNum = parseInt(hour, 10);
  if (period === 'PM' && hourNum !== 12) hourNum += 12;
  else if (period === 'AM' && hourNum === 12) hourNum = 0;
  return hourNum;
};

export const hourToTime = (hour) => {
  if (hour === 0) return '12:00 AM';
  if (hour <= 12) return `${hour}:00 ${hour === 12 ? 'PM' : 'AM'}`;
  return `${hour - 12}:00 PM`;
};

export const generateBookingHours = (startTime, totalHours) => {
  if (!startTime) return [];
  const startHour = timeToHour(startTime);
  if (startHour === null) return [];
  const hours = [];
  for (let i = 0; i < totalHours; i++) {
    const hour = startHour + i;
    if (hour <= 22) hours.push(hourToTime(hour));
  }
  return hours;
};

export const isTimeRangeAvailable = (startTime, totalHours, bookedTimes) => {
  if (!startTime) return false;
  return !generateBookingHours(startTime, totalHours).some((h) => bookedTimes.includes(h));
};

export const generateTimeSlots = () => {
  const slots = [];
  for (let hour = 6; hour <= 22; hour++) {
    slots.push(
      hour <= 12
        ? `${hour === 12 ? 12 : hour}:00 ${hour === 12 ? 'PM' : 'AM'}`
        : `${hour - 12}:00 PM`
    );
  }
  return slots;
};
